import React, { useEffect, useState } from "react";
import { Card, CardBody, Table, Row, CardHeader } from "reactstrap";
import { H6, P } from "../../../AbstractElements";
import moment from "moment";
export const TaskHeadings1 = [
  {
    name: "Booking No",
    value: "megaCabsBookingNo",
  },
  {
    name: "Start time",
    value: "tripStartTime",
  },
  // {
  //     name:'End time',
  //     value:'tripEndTime'
  // },
  {
    name: "Pickup date",
    value: "pickUpDateTime",
  },
  {
    name: "Booking via",
    value: "bookingViaType",
  },
  {
    name: "Pickup zone",
    value: "pickUpZoneName",
  },
  {
    name: "Car type",
    value: "carType",
  },
  // {
  //     name:'Zone',
  //     value:'zone'
  // },
  // {
  //     name:'Distance',
  //     value:'bookingTotalDistance'
  // },
  // {
  //     name:'Fare',
  //     value:'bookingTotalFare'
  // },
];

export const TaskHeadings2 = [
  {
    name: "Driver Name",
    value: "driverName",
  },
  {
    name: "Phone",
    value: "driverMobile",
  },
  // {
  //   name: "Type",
  //   value: "type",
  // },
  {
    name: "Ratings",
    value: "driverRatingAvg",
  },
  {
    name: "Car number",
    value: "carNo",
  },
  // {
  //   name: "Car type",
  //   value: "carType",
  // },
];

export const TaskData1 = {
  megaCabsBookingNo: "BNC922030082",
  tripStartTime: moment(new Date()).format("MMM DD,YYYY HH:mm"),
  end_time: moment(new Date()).format("MMM DD,YYYY HH:mm"),
  pickUpDateTime: moment(new Date()).format("MMM DD,YYYY HH:mm"),
  pickUpZoneName: "Zone1",
  carType: "MUV",
  distance: "17kms",
  fare: "INR 800",
  bookingViaType: "AirportBooking",
};

export const TaskData2 = {
  driverName: "Ram kumar",
  driverMobile: "9876543210",
  type: "Primary",
  driverRatingAvg: "4.8",
  carNo: "KA - 01-AB - 7869",
  car_type: "MUV",
};

const TripDetails = ({ onClickFlag, mapClickData }) => {
  const [isToggled, setIsToggled] = useState(false);
  const Table1Data = TaskHeadings1.map((element, i) => {
    let value = mapClickData[element.value] ? mapClickData[element.value] : "-";
    if (
      (element.value == "tripStartTime" ||
        element.value == "tripEndTime" ||
        element.value == "pickUpDateTime") &&
      value != "-"
    ) {
      value = moment(value).format("MMM DD,YYYY HH:mm");
    }
    return (
      <tr key={i}>
        <td>
          <P>{element.name}</P>
        </td>
        <td>
          <P>{value}</P>
        </td>
      </tr>
    );
  });

  const Table2Data = TaskHeadings2.map((element, i) => {
    let value = mapClickData["carCurrentStatus"]
      ? mapClickData["carCurrentStatus"][element.value]
        ? mapClickData["carCurrentStatus"][element.value]
        : "-"
      : "-";
    if (element.value == "type" && "isPrimaryDriver" in mapClickData) {
      console.log(mapClickData, "mapClickData");
      console.log(
        mapClickData?.isPrimaryDriver,
        "mapClickData?.isPrimaryDriver"
      );
      value = mapClickData?.isPrimaryDriver ? "Primary" : "Secondary";
    }
    return (
      <tr key={i}>
        <td>
          <P>{element.name}</P>
        </td>
        <td>
          <P>{value}</P>
        </td>
      </tr>
    );
  });

  return (
    <Card className="dashboard-trip-details">
      <CardHeader>
        <div className="dashboard-trip-details-title">
          {!isToggled ? "Trip Details" : "Driver Details"}
        </div>
        <div className="custom-toggle-switch">
          <input
            type="checkbox"
            checked={isToggled}
            onChange={(e) => {
              setIsToggled(!isToggled);
            }}
            id={"switch"}
          />
          <label htmlFor={"switch"}></label>
        </div>
      </CardHeader>
      <CardBody>
        {onClickFlag ? (
          <div>
            {!isToggled ? (
              <div className="table-responsive">
                <table className="booking-list-table">
                  <thead>
                    <tr></tr>
                  </thead>
                  <tbody>{Table1Data}</tbody>
                </table>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="booking-list-table">
                  <thead>
                    <tr></tr>
                  </thead>
                  <tbody>{Table2Data}</tbody>
                </table>
              </div>
            )}
          </div>
        ) : (
          <div>
            {!isToggled ? (
              <div className="table-responsive">
                <table className="booking-list-table">
                  <thead>
                    <tr></tr>
                  </thead>
                  <tbody>
                    {TaskHeadings1.map((element, i) => {
                      return (
                        <tr key={i}>
                          <td>
                            <P>{element.name}</P>
                          </td>
                          <td>
                            <P>{'-'}</P>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="booking-list-table">
                  <thead>
                    <tr></tr>
                  </thead>
                  <tbody>
                    {TaskHeadings2.map((element, i) => {
                      return (
                        <tr key={i}>
                          <td>
                            <P>{element.name}</P>
                          </td>
                          <td>
                            <P>{'-'}</P>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default TripDetails;
